import { gql } from '@apollo/client';

export const PATIENT_AND_USER_DETAILS_QUERY = gql`
  query PatientAndUserDetails($id: ID!) {
    patient(id: $id) {
      id
      patientState
      lastVisitedSection
      regFormStatus
      lock {
        lockedBy
        readOnly
        lockedByName
      }
      firstName
      middleName
      lastName
      ida
      gender
      dob
      namePrefix
      preferredName
      dobRawDay
      dobRawMonth
      dobRawYear
      primaryPhone
      secondaryPhone
      email
      residentialAddressLine1
      residentialAddressLine2
      residentialAddressCity
      residentialAddressState
      residentialAddressPostcode
      residentialAddressCountry
      postalAddressSameAsResidential
      postalAddressLine1
      postalAddressLine2
      postalAddressCity
      postalAddressState
      postalAddressPostcode
      postalAddressCountry
      address {
        id
        formattedAddress
      }
      userProfile {
        id
        systemState
      }
      attachments {
        id
        filename
        documentType
        filesize
        submitted
        encounterDate
        isRegistrationAttachment
      }
      attachmentAcknowledged
      emergencyContact {
        id
        firstName
        lastName
        relationship
        mobilePhoneNumber
        homePhoneNumber
        email
        authorisedForEnquiries
        supportPerson
      }
      nextOfKinContact {
        id
        firstName
        lastName
        relationship
        mobilePhoneNumber
        homePhoneNumber
        email
        authorisedForEnquiries
        supportPerson
      }
      altContactProvided
      referringFirstName
      referringLastName
      referringPractice
      referringIsInMosaiq
      gpFirstName
      gpLastName
      gpPractice
      gpIsInMosaiq
      referrersOtherSpecialists
      healthMedicareDvaOption
      healthMedicareNumber
      healthMedicareIrn
      healthMedicareExpiry
      healthDvaExpiry
      healthDvaNumber
      healthDvaType
      healthPrivateHealthInsurance
      healthPrivateHealthFundName
      healthPrivateHealthFundNumber
      healthPensionCard
      healthPensionCardNumber
      healthPensionCardExpiry
      countryOfBirth
      languageAtHome
      occupation
      heritage
      maritalStatus
      interpreterRequired
      informationNoticeContent
      informationNoticeAccepted
      informationNoticeAlliedHealthReceiveUpdates
      additionalComments
      diffMqData
      ambulanceMembership
      ambulanceMembershipNumber
    }
    titleRefData: listData(category: "nameTitle") {
      id
      name
    }
    relationshipsRefData: listData(category: "relationships") {
      id
      name
    }
    heritageRefData: listData(category: "heritage") {
      id
      name
    }
    maritalStatusRefData: listData(category: "maritalStatus") {
      id
      name
    }
    countryOfBirthRefData: listData(category: "countryOfBirth", removeOutdated: true) {
      id
      name
    }
    genderRefData: listData(category: "gender") {
      id
      name
    }
    languageSpokenRefData: listData(category: "languages") {
      id
      name
    }
    medicareTypeRefData: listData(category: "healthFund") {
      id
      name
      appKey
    }
    dvaTypeRefData: listData(category: "dvaCardType") {
      id
      name
      appKey
    }
    ausStateRefData: listData(category: "australiaStates") {
      id
      name
    }
    user {
      id
      isPso
    }
    profile(id: $id) {
      id
      showDistressThermometer
      patientFeatures(id: $id) {
        doctorReferralLookupEnabled
      }
    }
    healthAssessment(id: $id) {
      id
      status
    }
    covidScreening(id: $id) {
      id
      status
    }
    distressThermometerInitial(patientId: $id) {
      id
      status
    }
    distressThermometerEot(patientId: $id) {
      id
      status
    }
  }
`;
